export default "__VITE_ASSET__DzsjltA$__";